import { defineStore } from 'pinia'
import { store } from '@/store'
import type { IGobalConfig } from '@/types/globalConfig'
import { useStorage } from '@/hooks/system/useStorage'
import { EGlobalConfig } from '@/enums/cacheEnum'
import { defHttp } from '@/utils/http'
// import { axiosSetting } from '@/setting/axiosSetting'
import { changeFavicon } from '@/utils'
import { useChangeLang } from '@/hooks/system/useVuei18n'
import { setPrimaryColor, themeMap, useTheme } from '@/hooks/system/useTheme'

/** 全局配置 */
export const useConfigStore = defineStore({
  id: 'config',
  state: (): IGobalConfig => ({
    token: useStorage.ls.get(EGlobalConfig.token),
    apiSrc: useStorage.ls.get(EGlobalConfig.apiSrc) || '',
    pushSrc: useStorage.ls.get(EGlobalConfig.pushSrc) || '',
    platformName: 'World Cup',
    icoUrl: './favicon.ico',
    handicap: useStorage.ls.get(EGlobalConfig.handicap) || 1,
    language: useStorage.ls.get(EGlobalConfig.language) || 'CMN',
    color: useStorage.ls.get(EGlobalConfig.color) || 'daily',
    currencyId: useStorage.ls.get(EGlobalConfig.currencyId) || null,
    cbs: useStorage.ls.get(EGlobalConfig.cbs) || '',
    tutorialPop: useStorage.ls.get(EGlobalConfig.tutorialPop) || null,
    themeText: useStorage.ls.get(EGlobalConfig.themeText) || null,
    nickname: useStorage.ls.get(EGlobalConfig.nickname) || null,
    noType: useStorage.ls.get(EGlobalConfig.noType) || '',
    hideBigData: useStorage.ls.get(EGlobalConfig.hideBigData) || '0',
    enableSportFilter: useStorage.ls.get(EGlobalConfig.enableSportFilter) || '0',
  }),
  getters: {

  },
  actions: {
    setKey(key: string, value: any) {
      this[key] = value
      useStorage.ls.set(key, value)
    },
    /** 配置 config 参数 */
    setConfig(key: string, value: any) {
      this.setKey(key, value)

      const { pcFgColor } = this.themeText || {}

      switch (key) {
        /** 接口地址 */
        case EGlobalConfig.apiSrc:
          defHttp.setRequestOptions({
            apiUrl: this.apiSrc,
          })
          break

        /** 设置语言 */
        case EGlobalConfig.language:
          console.log('[]设置语言', value)
          useChangeLang(value || this.language)
          break

        /** 设置主题 */
        case EGlobalConfig.color:
          useTheme(themeMap[this.color])
          break

        /** 设置主题色 */
        case EGlobalConfig.themeText:
          setPrimaryColor(pcFgColor)
          break

        default:
          break
      }

      this.setBaseWebsite()
    },

    /** 设置网站基本信息 */
    setBaseWebsite() {
      // 标题
      // document.title = this.platformName
      // 网站图标
      changeFavicon('./favicon.ico')
    },

    setCurrencyId(id) {
      this.setKey('currencyId', id)
    },
  },
})

// Need to be used outside the setup
export function useConfigStoreWithOut() {
  return useConfigStore(store)
}
